import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ScreenAccessGuardService } from './services/screen-access-guard.service';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [MsalGuard],
    data: {
      screenAccess: ['RECS', 'ALL'],
    },
  },
  {
    path: 'session/:sessionId',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['RECS', 'ALL'],
    },
  },
  {
    path: 'void/detail/:id',
    loadComponent: () => import('./pages/void-detail/void-detail.page').then((m) => m.VoidDetailPage),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['VOIDS', 'ALL'],
    },
  },
  {
    path: 'void',
    loadComponent: () => import('./pages/void-report/void-report.page').then((m) => m.VoidReportPage),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['VOIDS', 'ALL'],
    },
  },
  {
    path: 'history',
    loadComponent: () => import('./pages/history/history.page').then((m) => m.HistoryPage),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['RECS', 'ALL'],
    },
  },
  {
    path: 'summary/:sessionId',
    loadComponent: () =>
      import('./pages/summary/summary.page')
        .then((m) => m.SummaryPage)
        .catch((error) => {
          console.error('Error loading SummaryPage:', error);
          throw new Error('Failed to load SummaryPage');
        }),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['RECS', 'ALL'],
    },
  },
  {
    path: 'report',
    loadComponent: () =>
      import('./pages/report/report.page')
        .then((m) => m.ReportPage)
        .catch((error) => {
          console.error('Error loading ReportPage:', error);
          throw new Error('Failed to load ReportPage');
        }),
    canActivate: [MsalGuard, ScreenAccessGuardService],
    data: {
      screenAccess: ['RECS', 'ALL'],
    },
  },
  // {
  //   path: 'void-report',
  //   loadComponent: () => import('./pages/void-report/void-report.page').then((m) => m.VoidReportPage),
  // },
];
